<template>
<div class="modules">
    <div class="fund-container">
        <div class="summary">
            <h1 class="title">  {{ $t("lang.Fund") }}</h1>
            <!-- <div class="tools">
                <el-button size="small" type="primary">充值</el-button>
                <el-button size="small">提现</el-button>
                <el-button size="small">转账</el-button>
                <el-button size="small">划转</el-button>
                <el-button size="small">钱包历史记录</el-button>
            </div> -->
        </div>
        <div class="card">
            <!-- <div class="hd">
                <h2 class="title">
                    <div class="text">总资产估值</div>
                    <div class="val">
                        <div>
                            <el-select v-model="balance" class="select" size="small">
                                <el-option value="0.00017782" label="0.00017782 BTC"></el-option>
                            </el-select>
                            <div class="exchange">
                                <span class="exchange-show"><span class="num">0.00017782</span> <span class="unit">BTC</span></span>
                                <el-dropdown>
                                    <span class="el-dropdown-link"><i class="el-icon-arrow-down"></i></span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item>0.00017782 BTC</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                        <div class="symbol">≈</div>
                        <div class="dollar">$6.07</div>
                    </div>
                </h2>
                <div class="tools">
                    <div class="item">
                        <div class="item-icon"></div>
                        <div class="item-text">买币/卖币</div>
                    </div>
                    <div class="item">
                        <div class="item-icon"></div>
                        <div class="item-text">支付</div>
                    </div>
                    <div class="item">
                        <div class="item-icon"></div>
                        <div class="item-text">礼品卡</div>
                    </div>
                </div>
            </div> -->
            <div class="bd">
                <div class="table-wrapper">
                    <!-- <div class="table-tools">
                        <div class="search-wrapper">
                            <el-select v-model="coinType"  placeholder="请选择"  @change="coinChange">
                              <el-option class="option"   v-for="(item) in filterOption" :key="item.id"  :label="item.fullName" :value="item.id">  </el-option>
                            </el-select> 
                           <el-input prefix-icon="el-icon-search" placeholder="搜索币种" /> 
                        </div>
                        <el-checkbox>隐藏0资产</el-checkbox>
                    </div> -->
                    <div class="table-inner">
                        <el-table :data="page">
                            <el-table-column :label="$t('lang.Fund')" prop="btFullName">
                                <template slot-scope="scope">
                                    <img class="icon"  :src="api + scope.row.btIcon" />
                                    <span >{{ scope.row.btFullName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('lang.alls')" prop="incomeRevoCoin">
                                <template slot-scope="scope">
                                  
                                    <span >{{ scope.row.surplusRevoCoin }}</span>
                                    <span >{{ scope.row.btUnit }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('lang.available')" prop="surplusRevoCoinAdvance">
                                <template slot-scope="scope">
                                   
                                    <span >{{ scope.row.surplusRevoCoinAdvance }}</span>
                                    <span >{{ scope.row.btUnit }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('lang.Frozen')" prop="freezeCoin">
                                <template slot-scope="scope">
                                 
                                    <span>{{ scope.row.freezeCoin }}</span>
                                    <span >{{ scope.row.btUnit }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet,axiosPost} from '@/api/api';
import EventBus from '@/utils/EventBus';

export default {
    name:'payment',
    components:{},
    data(){
        return {
            Language: "en",
            form:{},
            url:{
                page:BASE_GLOB_API+'/kanban/wallet/page',
                platform:BASE_GLOB_API+'/kanban/coin/platform',
            },
            api:BASE_GLOB_API,
            filterOption:[],
            coinType:'',
            page:[],
            lang: "",
            selectedNetPc:{}
        }
    },
    created(){
        this.lang = sessionStorage.getItem("Language")
        this.selectedNetPc = JSON.parse( sessionStorage.getItem("selectedNetPc"));
        if(this.selectedNetPc){
            this.fetchUserPage(this.selectedNetPc.btPlatformId)
        }
        EventBus.$on('share', value => {
           if(value){
               this.selectedNetPc = JSON.parse( sessionStorage.getItem("selectedNetPc"));
                if(this.selectedNetPc){
                    this.fetchUserPage(this.selectedNetPc.btPlatformId)
                }
           }

        })
        
    },
    methods:{
        coinChange(e){
            console.log("e:",e)
            this.fetchUserPage(e)
        },
        fetchUserPlatform(){
            axiosGet(this.url.platform).then(res=>{
               if(res.code ==200){
                //  this.filterOption = res.result
                //   let arrDrp =[{fullName:'eth',id:'3'},{fullName:'htl',id:'122'},{fullName:'tey',id:'222'}];
                  let arrayList =res.result,fullNameList =[]
                   arrayList.forEach(item=>{
                     if(item.enabled){
                        let are ={
                            enabled:item.enabled,
                            fullName:item.fullName,
                            icon:item.icon,
                            id:item.id,
                            networkVos:item.networkVos,
                            shortName:item.shortName,
                            unit:item.unit,
                         }
                     fullNameList.push(are)
                     }
                    
                   });
                   this.filterOption = fullNameList
                   this.coinType = this.filterOption[0].id
                   this.fetchUserPage(this.filterOption[0].id)
               }else{
                    this.$message.error(res.message);
                }
            })
           
        }, 
        fetchUserPage(value){
            axiosPost(this.url.page,{}).then(res=>{
               if(res.code ==200){
                  this.page =res.result.records
               }else{
                    this.$message.error(res.message);
                }
            })
           
        }, 
    }
}
</script>
<style lang="less" scoped>
.fund-container {
    .summary {
        background:#f4f5f6; border-radius:4px; padding:30px; display:flex; justify-content: space-between; align-items: center; margin-bottom:30px;
    }
    .card {
        .hd {
            display:flex; justify-content: space-between; align-items: center; padding:0 0 20px; border-bottom:#e6e6e6 1px solid; margin-bottom:20px;
            .title {
                .text {
                    font-size:18px; font-weight:700; padding:0 0 10px;
                }
                .val {
                    display:flex; justify-content: flex-start; align-items: center;
                    ::v-deep .select {
                        .el-input {
                            position:relative; width:auto;
                            .el-input__inner {border:0 none; font-size:24px; font-weight:700; font-family: 'bebas_neueregular'; padding-left:0; display:block; width:100%; min-width:0;}
                            .el-input__suffix {
                                background:#f4f5f6; border-radius:4px;
                            }
                            &:after {
                                content:""; display:block; border-bottom:#ccc 1px dashed; margin-right:32px;
                            }
                        }
                    }
                    .exchange {
                        display:flex; justify-content: flex-start; align-items: center; margin-right:6px;
                        .exchange-show {
                            display:flex; justify-content: flex-start; align-items: center;
                            .num {font-family: 'bebas_neueregular'; font-size:24px; display:block;}
                            .unit {font-size:20px; font-weight:700; display:block; margin:0 8px 0 4px;}
                        }
                        .el-dropdown-link {
                            width:26px; height:26px; display:block; border-radius:4px; background:#f4f5f6; display:flex; justify-content: center; align-items: center; margin-left:4px; cursor: pointer;
                        }
                    }
                    .symbol, .dollar {
                        font-size:20px; color:#666; margin:0 4px; font-weight:700;
                    }
                }
            }
            .tools {
                display:flex; justify-content: space-between; align-items: center;
                .item {
                    padding:0 10px;
                }
            }
        }
        .bd {
            .table-wrapper {
                .table-tools {
                    display:flex; justify-content: flex-start; align-items: center;
                    .search-wrapper {
                        margin-right:10px;
                    }
                    ::v-deep .el-checkbox {
                        .el-checkbox__label {font-weight:normal;}
                    }
                }
                .table-inner {
                    padding:10px 0;
                    .icon{
                        width:6%; height:6%;
                    }
                }
            }
        }
    }
}
.select-option-coin-item {
    display:flex; justify-content: flex-start; align-items: center;
}
.select-option-network-item {}
</style>